<template>
	<div class="footer">
		<div class="footer__version">
			<div class="footer__version-custom">
				<span>Versão {{ getVersion() }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import packageInfo from './../../../../package.json';

export default {
	name: 'Footer',
	methods: {
		getVersion() {
			return packageInfo.version;
		},
	},
};
</script>

<style lang="scss">
@import 'Footer.scss';
</style>
